/**
 * Integration pages.
 */
import { generateTechTask } from '@/helpers/generated-tech-task'
import { RouteGroup } from '@/types/routing-types'


export default [
    generateTechTask('API Keys', 'api-keys', RouteGroup.INTEGRATION),
    generateTechTask('Audit Integration', 'audit-integration', RouteGroup.INTEGRATION),
    {
        name: 'integration-app-settings',
        path: '/integration/app-settings',
        component: () => import('@/pages/integration/UpdateAppSettings/index.vue'),
        meta: {
            title: 'Integration App Settings',
            updateTitle: true,
            displayHome: true,
            displayNav: true,
            group: RouteGroup.INTEGRATION
        }
    },
    generateTechTask('SuccessWare Settings', 'integration-settings-successware', RouteGroup.INTEGRATION),
    generateTechTask('ServiceFusion Settings', 'integration-settings-servicefusion', RouteGroup.INTEGRATION),
    generateTechTask('ServiceLine Setup', 'integration-serviceline', RouteGroup.INTEGRATION),
    generateTechTask('ServiceTitan Settings', 'integration-settings-servicetitan', RouteGroup.INTEGRATION),
    generateTechTask('Microsoft Dynamics Settings', 'integration-settings-microsoft-dynamics', RouteGroup.INTEGRATION),
    generateTechTask('Pool Brain Settings', 'integration-settings-pool-brain', RouteGroup.INTEGRATION),
    {
        name: 'integration-zapier',
        path: '/integration/zapier',
        component: () => import('@/pages/integration/ZapierIntegration.vue'),
        meta: {
            title: 'Zapier Setup',
            updateTitle: true,
            displayHome: true,
            displayNav: true,
            group: RouteGroup.INTEGRATION
        }
    },
    {
        name: 'integration-successware',
        path: '/integration/successware',
        component: () => import('@/pages/integration/SuccessWareIntegration/index.vue'),
        meta: {
            title: 'SuccessWare Settings (OLD)',
            updateTitle: true,
            displayHome: true,
            displayNav: true,
            group: RouteGroup.INTEGRATION
        }
    },
    generateTechTask('FieldEdge Settings', 'integration-settings-fieldedge', RouteGroup.INTEGRATION),
    generateTechTask('Job Lookup', 'job-lookup', RouteGroup.INTEGRATION),
    {
        name: 'successware-job-lookup',
        path: '/successware-job-lookup',
        component: () => import('@/pages/integration/SuccessWareJobLookup/index.vue'),
        meta: {
            title: 'SuccessWare Job Lookup',
            updateTitle: true,
            displayHome: true,
            displayNav: true,
            group: RouteGroup.INTEGRATION
        }
    },
    {
        name: 'technician-audit',
        path: '/technician-audit',
        component: () => import('@/pages/integration/TechnicianAudit.vue'),
        meta: {
            title: 'Audit Technicians',
            updateTitle: true,
            displayHome: true,
            displayNav: true,
            group: RouteGroup.INTEGRATION
        }
    }
]
